<div class="d-flex vh-100">

    <div class="d-flex flex-column w-100">
        <div class="h-100">
            <div class="d-flex align-items-center h-100 w-100" *ngIf="!hasCode; else loading">
                <!-- If Embedded -->
                <div class="aura__start">
                    <div class="aura__start--heading">
                        <div class="mb-1"><img src="../../../assets/icons/avatar.svg" alt="" width="50" /></div>
                        <span *ngIf="isEmbedded">Aura</span>
                        <span *ngIf="!isEmbedded">Aura AI Assistant</span>
                    </div>
                    <div class="aura__start--description">

                        <span *ngIf="isEmbedded">
                          Invalid user token. Please reopen this window or refresh this page.
                        </span>
                        <div *ngIf="!isEmbedded">
                            <hr>
                            <button class="ui-button" kendoButton size="medium" rounded="large" themeColor="primary"
                                fillMode="flat" (click)="redirectToLogin()">
                              Log In via Microsoft Single Sign-On
                            </button>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    </div>
</div>

<ng-template #loading>
    <div class="loading-dots h-100 align-items-center">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
    </div>
</ng-template>
